export default __webpack_public_path__ + "static/media/leonie.eb0eb96f.png";